import apiAuth from "./apiAuth";
import authHeader from "./auth-header";
import { API_URL } from "../config/api";

class TechnicianService {
  getTechnicians() {
    return apiAuth.get(API_URL + "technicians/", { headers: authHeader() });
  }

  createTechnician(data) {
    return apiAuth.post(API_URL + "technicians/", data, { headers: authHeader() });
  }

  updateTechnician(id, data) {
    return apiAuth.patch(API_URL + `technicians/${id}/`, data, { headers: authHeader() });
  }

  deleteTechnician(id) {
    return apiAuth.delete(API_URL + `technicians/${id}/`, { headers: authHeader() });
  }

  getLeaves(from, to) {
    return apiAuth.get(API_URL + `technician-leaves/?from=${from}&to=${to}`, { headers: authHeader() });
  }

  createLeave(data) {
    return apiAuth.post(API_URL + "technician-leaves/", data, { headers: authHeader() });
  }

  updateLeave(id, data) {
    return apiAuth.patch(API_URL + `technician-leaves/${id}/`, data, { headers: authHeader() });
  }

  deleteLeave(id) {
    return apiAuth.delete(API_URL + `technician-leaves/${id}/`, { headers: authHeader() });
  }

  checkConflict(data) {
    return apiAuth.post(API_URL + "technician-leaves/check-conflict/", data, { headers: authHeader() });
  }
}

export default new TechnicianService();
